/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SpoListFilterColumnEnum {
    PARTNER = 'PARTNER',
    SUPPLYING_PACKING_PLANT = 'SUPPLYING_PACKING_PLANT',
    NUMBER = 'NUMBER',
    SENT_DATE = 'SENT_DATE',
    NUMBER_OF_MATERIALS = 'NUMBER_OF_MATERIALS',
    REASON = 'REASON',
    LAST_CHANGE_DATETIME = 'LAST_CHANGE_DATETIME',
    REQUESTED_DATE = 'REQUESTED_DATE',
    SPO_MAT_STATUS = 'SPO_MAT_STATUS',
    MATERIAL_ALERTS = 'MATERIAL_ALERTS'
}
